import React from 'react';
import {View as RNView, Text} from 'react-native';
import Swiper from '@softmedialab/react-native-web-swiper';
import {Props} from './model';
import {LogoToApp} from '../../../assets/images';
import {Link} from '../link';
import {Image} from '../image';

export const View = (props: Props) => {
  return (
    <RNView style={props.styles.goToAppContainer}>
      {/* @ts-expect-error Swiper types don't include children prop */}
      <Swiper key={props.href} onIndexChanged={props.onClose} loop={true} loopAnimation='spring'>
        <RNView style={props.styles.item}>
          <RNView style={props.styles.infoBlock}>
            <Image source={LogoToApp as any} height={50} width={50} />
            <RNView style={props.styles.textContainer}>
              <Text style={props.styles.header}>Единая социальная карта</Text>
              <Text style={props.styles.text}>Открыть в приложении</Text>
            </RNView>
          </RNView>
          <Link
            testID='goToApp-link-id'
            style={props.styles.link}
            accessibilityLabel='в приложение'
            dataSetClass='header-link'
            href={props.href}
            external>
            <Text style={props.styles.linkText}>ОТКРЫТЬ</Text>
          </Link>
        </RNView>
        <RNView />
      </Swiper>
    </RNView>
  );
};
